import React from "react";
import TradesRequestsTableRow from "./TradesRequestsTableRow";
import { add_shift_attributes } from "../../utilities/helpers";
import EmptyState from "../../shared/helpers/EmptyState";



export default function TradesRequestsTable(props) {


  let tradeRequests = props.shiftPoolData.filter(
    (v) => v.status === "PENDING_TRADE" && v.pending_pickups.length > 0
  );

  const hasTradeRequests = tradeRequests.length > 0;

  return (
    <>
      {hasTradeRequests ? (
        <div className="mt-12">
          <div className="flex items-center px-6">
            <div className="flex-auto">
              <h1 className="text-xl font-bold text-slate-900">Requests</h1>
            </div>
          </div>
          <div className="mt-8 flex flex-col">
            <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 min-w-full">
              <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                <div className="overflow-hidden">
                  <table className="min-w-full divide-y divide-slate-100">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="w-[40%] py-3 pl-6 pr-3 text-left text-xs font-semibold text-slate-500"
                        >
                          Sender
                        </th>
                        <th
                          scope="col"
                          className="w-[14%] px-3 py-3"
                        >
                        </th>
                        <th
                          scope="col"
                          className="w-[40%] pr-6 py-3 text-left text-xs font-semibold text-slate-500"
                        >
                          Receiver
                        </th>
                        <th
                          scope="col"
                          className="w-[6%] relative py-3 pl-3 pr-6"
                        >
                          <span className="sr-only">Actions</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100 bg-white">
                      {/* {trades.map((trade) => (
                        <TradesRequestsTableRow trade={trade} />
                      ))} */}
                      {tradeRequests.map((request, index) =>
                        request.pending_pickups.map((pickup, pickupIndex) => {
                          const senderTrade = add_shift_attributes(request);
                          const receiverTrade =
                            pickup.shift_pickup &&
                            add_shift_attributes(pickup.shift_pickup);
                          return (
                            pickup.shift_pickup && (
                              <TradesRequestsTableRow
                                key={index}
                                senderShiftId={request.id}
                                senderTrade={senderTrade}
                                senderName={senderTrade.name}
                                senderDate={senderTrade.date}
                                senderShift={senderTrade.shift}
                                senderRole={senderTrade.role}
                                senderStation={senderTrade.station}
                                senderRoleType={senderTrade.roleType}
                                pickupUUID={pickup.uuid}
                                receiverName={
                                  pickup.employee_pickup.first_name +
                                  " " +
                                  pickup.employee_pickup.last_name
                                }
                                receiverTrade={receiverTrade}
                                receiverDate={receiverTrade.date}
                                receiverShift={receiverTrade.shift}
                                receiverRole={receiverTrade.role}
                                receiverStation={receiverTrade.station}
                                receiverRoleType={receiverTrade.roleType}
                                manager_reject_shift_drop={
                                  props.manager_reject_shift_drop
                                }
                                manager_approve_shift_pickup={
                                  props.manager_approve_shift_pickup
                                }
                                manager_shift_pickup_request_response={
                                  props.manager_shift_pickup_request_response
                                }
                                roleNames={props.roleNames}
                              />
                            )
                          );
                        })
                      )}
                    </tbody>
                  </table>
                  <div className="border-b border-slate-100"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <EmptyState
          title="Requests"
          description="No trade requests at the moment"
        />
      )}
    </>
  );
}
